export default __webpack_public_path__ + "maps-guides-view-annotation-marker-popup-960-0c3203a9c4654b71b8c6aee26f959d69.png";